import axios from 'axios'

export const getFiltersMixin = {
    methods: {
        async getFiltersFromAPI() {
            const params = this.getFilters()
    
            const response = await axios.get('/get-filters', { 
                params,
            })
            
            Object.assign(this.options, response.data)
        },
    },

    created() {
        this.getFiltersFromAPI()
    },
}